import _ from "lodash";

export const applyMethodToObjectProps = (Schema, fieldsToUpdate, methodToApply) => {
  const object = _.cloneDeep(Schema);
  fieldsToUpdate.forEach((field) => {
    const { path, rule, condition } = field;

    const keys = path.split(/\.|\[\]/).filter((key) => key !== "");

    const traverse = (obj, keys, index = 0) => {
      if (index === keys.length - 1) {
        if (rule === "allProperties" && typeof obj[keys[index]] === "object") {
          const target = obj[keys[index]];
          for (const prop in target) {
            if (target.hasOwnProperty(prop)) {
              if (!condition || condition(target[prop])) {
                target[prop] = methodToApply(target[prop]);
              }
            }
          }
        } else if (rule === "field" && obj.hasOwnProperty(keys[index])) {
          if (!condition || condition(obj[keys[index]])) {
            obj[keys[index]] = methodToApply(obj[keys[index]]);
          }
        }
      } else {
        const key = keys[index];
        if (Array.isArray(obj[key])) {
          obj[key].forEach((item) => traverse(item, keys, index + 1));
        } else if (obj[key] && typeof obj[key] === "object") {
          traverse(obj[key], keys, index + 1);
        }
      }
    };

    traverse(object, keys);
  });

  return object;
};

/**
 * Demo for `updateObjectFields` function
 */

// Sample object
// const object = {
//     title: "Original Title", // String field we want to update
//     p1: {
//       l1: "world",
//       l2: "hello",
//     },
//     p2: {
//       pp1: {
//         m1: "hello world",
//         m2: "skip this", // Shouldn't update due to condition
//       },
//     },
//     sections: [
//       {
//         id: "mrNumber",
//         type: "input",
//         labelValue: "MR#", // Should be updated
//       },
//       {
//         id: "priority",
//         type: "select",
//         labelValue: "Priority",
//       },
//     ],
//     newSections: [
//       {
//         id: 1,
//         props: [
//           {
//             id: "1",
//             type: "123",
//             labelValue: "value", // Should be updated
//           },
//           {
//             id: "2",
//             type: "123",
//             labelValue: "valuee", // Should be updated
//           },
//         ],
//       },
//       {
//         id: 2,
//         props: [
//           {
//             id: "1",
//             type: "123",
//             labelValue: "value", // Should be updated
//           },
//           {
//             id: "2",
//             type: "123",
//             labelValue: "valuee", // Should be updated
//           },
//         ],
//       },
//     ],
//   };

// Define fields to update
//   const fieldsToUpdate = [
//     {
//       path: "title", // Directly targets the `title` field
//       rule: "field", // Rule to update a specific field
//       condition: (value) => typeof value === "string", // Only update if it's a string
//     },
//     {
//       path: "p1", // Target `p1` object
//       rule: "allProperties", // Update all its properties
//       condition: (value) => typeof value === "string", // Only update if the value is a string
//     },
//     {
//       path: "p2.pp1", // Target `pp1` within `p2`
//       rule: "allProperties", // Update all its properties
//       condition: (value) => value !== "skip this", // Skip updating if the value is "skip this"
//     },
//     {
//       path: "sections[].labelValue", // Target `labelValue` field in each element of `sections`
//       rule: "field", // Rule to update specific field
//       condition: (value) => value === "MR#", // Only update if `labelValue` is "MR#"
//     },
//     {
//       path: "newSections[].props[].labelValue", // Deeply nested field
//       rule: "field", // Rule to update a specific field
//       condition: (value) => value.startsWith("value"), // Only update if it starts with "value"
//     },
//   ];

// Define the method to apply
//   function languageService(value) {
//     return value.toUpperCase(); // Convert to uppercase
//   }

// Call the function
//   const updatedObject = updateObjectFields(object, fieldsToUpdate, languageService);

/**
 * Expected Output:
 * {
 *   title: "ORIGINAL TITLE", // Updated
 *   p1: {
 *     l1: "WORLD", // Updated
 *     l2: "HELLO", // Updated
 *   },
 *   p2: {
 *     pp1: {
 *       m1: "HELLO WORLD", // Updated
 *       m2: "skip this", // Not updated (condition failed)
 *     },
 *   },
 *   sections: [
 *     {
 *       id: "mrNumber",
 *       type: "input",
 *       labelValue: "MR#", // Updated
 *     },
 *     {
 *       id: "priority",
 *       type: "select",
 *       labelValue: "Priority", // Not updated (condition failed)
 *     },
 *   ],
 *   newSections: [
 *     {
 *       id: 1,
 *       props: [
 *         {
 *           id: "1",
 *           type: "123",
 *           labelValue: "VALUE", // Updated
 *         },
 *         {
 *           id: "2",
 *           type: "123",
 *           labelValue: "VALUEE", // Updated
 *         },
 *       ],
 *     },
 *     {
 *       id: 2,
 *       props: [
 *         {
 *           id: "1",
 *           type: "123",
 *           labelValue: "VALUE", // Updated
 *         },
 *         {
 *           id: "2",
 *           type: "123",
 *           labelValue: "VALUEE", // Updated
 *         },
 *       ],
 *     },
 *   ],
 * }
 */



// WEBPACK FOOTER //
// ./src/utils/ApplyMethodOnObjectProps.js